import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const CookieBanner = () => {
  const [seen, setSeen] = useState(() => localStorage.getItem("bz_cookie_ok") === "1");
  const { pathname } = useLocation();
  if (seen || pathname === "/semplice") return null;
  const ok = () => {
    localStorage.setItem("bz_cookie_ok", "1");
    setSeen(true);
  };
  return (
    <div className="fixed bottom-2 left-2 right-2 md:bottom-4 md:left-0 md:right-0 md:mx-auto md:max-w-md z-50 rounded-2xl border bg-white/95 backdrop-blur-xl px-4 py-2.5 md:p-5 shadow-lg flex items-center gap-3 md:block fade-up" data-testid="cookie-banner">
      <p className="text-xs md:text-sm text-slate-700 leading-snug md:leading-relaxed flex-1">
        Solo cookie tecnici, nessuna profilazione.{" "}
        <Link to="/cookie" className="underline text-[#1E3A8A]" data-testid="cookie-policy-link">Cookie policy</Link>
      </p>
      <Button onClick={ok} className="md:mt-3 rounded-full shrink-0" size="sm" data-testid="cookie-accept-btn">Ho capito</Button>
    </div>
  );
};
